import { useState } from "react";
import { useWebsiteData } from "./WebsiteDataContext";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import toast from "react-hot-toast";
import "./DemoForm.css";

function DemoForm({ onClose }) {

    const websiteData = useWebsiteData();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        selectedProducts: []
    });

    // Filter valid products
    const validProducts = websiteData.filter(
        (product) =>
            product.name !== "Dummy Product" &&
            product.device &&
            product.device.length > 0 &&
            product.device[0].image
    );

    // Flatten devices
    const allDevices = validProducts.flatMap(product =>
        product.device.map(device => ({
            ...device,
            productId: product.id,
            productName: product.name
        }))
    );

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleProductSelect = (deviceId) => {
        setFormData(prev => {
            const isSelected = prev.selectedProducts.includes(deviceId);

            return {
                ...prev,
                selectedProducts: isSelected
                    ? prev.selectedProducts.filter(id => id !== deviceId)
                    : [...prev.selectedProducts, deviceId]
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const selectedProductsDetails = formData.selectedProducts.map(deviceId => {
            const device = allDevices.find(d => d.id === deviceId);
            return {
                deviceId: device?.id,
                deviceName: device?.name || device?.webProductName,
                productName: device?.productName,
                price: device?.amount
            };
        });

        const payload = {
            clientName: formData.name,
            clientEmail: formData.email,
            clientPhoneNumber: formData.mobile,
            selectedProducts: selectedProductsDetails,
            totalProductsSelected: formData.selectedProducts.length,
            companyCode: initialAuthState.companyCode,
            unitCode: initialAuthState.unitCode,
            demoDate: new Date().toISOString().split("T")[0]
        };

        try {
            const response = await ApiService.post(
                "/demoLead/handleDemoLeadDetails",
                payload
            );

            const calResponse = await ApiService.get(
                "/google-meet-links/editGoogleMeetLink"
            );

            if (response.status === 200 || response.status) {
                toast.success("Demo booked successfully! Opening calendar...");
                // window.open(calResponse[0]["meetLink"], "_blank");
            } else {
                toast.error("Failed to book demo.");
            }
        } catch (error) {
            toast.error("Failed to book demo.");
            // window.open("https://calendar.app.google/tgGno7Nm5j7JXxZEA", "_blank");
        }

        onClose();

        setFormData({
            name: "",
            email: "",
            mobile: "",
            selectedProducts: []
        });
    };

    const isFormValid =
        formData.name && formData.email && formData.mobile;

    return (
        <div className="demo-modal-overlay" onClick={onClose}>
            <div
                className="demo-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <button className="demo-modal-close" onClick={onClose}>
                    ×
                </button>

                <div className="demo-modal-header">
                    <h2>Book Your Demo</h2>
                    <p>Fill in your details and select products you're interested in</p>
                </div>

                <form onSubmit={handleSubmit} className="demo-form">

                    <div className="demo-form-group">
                        <label>Full Name *</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter your full name"
                        />
                    </div>

                    <div className="demo-form-group">
                        <label>Email *</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter your email"
                        />
                    </div>

                    <div className="demo-form-group">
                        <label>Mobile *</label>
                        <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter your mobile number"
                        />
                    </div>

                    <div className="demo-products-selection">
                        <h3>Select Products for Discussion</h3>

                        {allDevices.length > 0 ? (
                            <div className="products-grid">
                                {allDevices.map((device, index) => {
                                    const isSelected =
                                        formData.selectedProducts.includes(device.id);

                                    const discountedPrice = Math.round(
                                        (device.amount || 100) *
                                        (1 - (device.discount || 0) / 100)
                                    );

                                    return (
                                        <div
                                            key={device.id || index}
                                            className={`product-select-card ${isSelected ? "selected" : ""
                                                }`}
                                            onClick={() => handleProductSelect(device.id)}
                                        >
                                            <div className="product-select-image">
                                                <img
                                                    src={device.image?.[0]}
                                                    alt={device.name || device.webProductName}
                                                    onError={(e) => {
                                                        e.target.src =
                                                            "/images/placeholder-product.png";
                                                    }}
                                                />
                                                <div className="product-checkbox">
                                                    <div
                                                        className={`checkbox ${isSelected ? "checked" : ""
                                                            }`}
                                                    >
                                                        {isSelected && "✓"}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="product-select-info">
                                                <h4>
                                                    {device.name || device.webProductName}
                                                </h4>
                                                <div className="product-price">
                                                    <span className="current-price">
                                                        {device.priceLabel}
                                                    </span>
                                                    {device.discount > 0 && (
                                                        <span className="old-price">
                                                            {device.mrpLabel}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="no-products-message">
                                <p>No products available for selection.</p>
                            </div>
                        )}
                    </div>

                    {/* <button
                        type="submit"
                        className="demo-submit-btn"
                        disabled={!isFormValid}
                    >
                        Submit & Open Calendar ↗
                    </button> */}

                    <button
                        type="submit"
                        className="demo-submit-btn"
                        disabled={!isFormValid}
                    >
                        Submit Form
                    </button>
                </form>
            </div>
        </div>
    );
}

export default DemoForm;